import { render } from "./CardSecondary.vue?vue&type=template&id=6f77133e"
import script from "./CardSecondary.vue?vue&type=script&lang=js"
export * from "./CardSecondary.vue?vue&type=script&lang=js"

import "./CardSecondary.vue?vue&type=style&index=0&id=6f77133e&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__